import React from 'react';
import { useTranslation } from 'react-i18next';


export default function ProductStock(props) {
  const { product, country } = props;
  const { t } = useTranslation();

  if (product.stock === null) {
    return null
  }

  if (country.shortage && product.isShortage) {
    return (
      <div className="stock-container">{t('Shortage reference, please contact your affiliate for availability.')}</div>
    );
  }

  return (
    <div className="stock-container">
      <div className={`stock stock-${product.stock}`}></div>
      <span className="stock-text">{t('stock.' + product.stock)}</span>
    </div>
  );
}
